import axios from "axios";

// Actions
export const FORGET_PERSONAL_USER_REQUEST = "gdpr/FORGET_PERSONAL_USER_REQUEST";
export const FORGET_PERSONAL_USER_SUCCESS = "gdpr/FORGET_PERSONAL_USER_SUCCESS";
export const FORGET_PERSONAL_USER_FAILURE = "gdpr/FORGET_PERSONAL_USER_FAILURE";

// Reducer
export const initialState = {
  loading: false,
  error: null,
  forgetUserSuccess: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FORGET_PERSONAL_USER_REQUEST:
      return { ...state, error: null, loading: true };
    case FORGET_PERSONAL_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        forgetUserSuccess: true
      };
    case FORGET_PERSONAL_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

// Action Creators
export const forgetPersonalUser = () => async (dispatch, getState) => {
  const {
    paths: { api }
  } = getState();
  dispatch({ type: FORGET_PERSONAL_USER_REQUEST });
  try {
    await axios.post(`${api}/forgetMe`);
    dispatch({ type: FORGET_PERSONAL_USER_SUCCESS });
  } catch (error) {
    dispatch({ type: FORGET_PERSONAL_USER_FAILURE, payload: error });
  }
};

// Selectors

export const isUserForgotten = state =>
  state.gdpr.accountRemoval.forgetUserSuccess;

export const accountRemovalPending = state => state.gdpr.accountRemoval.loading;

export const accountRemovalError = state => state.gdpr.accountRemoval.error;
